import { Component, Input, OnInit } from '@angular/core';
import { Cloudinary } from 'services/cloudinary';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { Subscription } from 'rxjs';
import { XmStore, XmStoreUtil } from 'core/services';
import { MyAccountModal } from 'my-account/services/modal';
import { XmPayAsYouGoModal } from 'my-account/shared/modals/pay-as-you-go/pay-as-you-go';
import { CmsAddonPlans, CmsMyAccountModals } from 'store/cms/models';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'addon-summary-pointers',
    templateUrl: './addon-summary-pointers.html',
    styleUrls: ['./addon-summary-pointers.scss'],
    standalone: false
})
export class AddonSummaryPointers implements OnInit {
    @Input() public percentage: number;
    @Input() public pageData: CmsLoaderContent;
    
    public planData: CmsAddonPlan;
    public summaryPageData: CmsAddonSummaryData;
    public intent: string;
    public features: CmsAddRemoveConfirmPointer[];
    public circleCheckGreyIcon: MediaImageOptions;

    private addonsUtil: AddonsUtil;
    private addonType: string;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private accountModal: MyAccountModal;
    private payAsYouGoModalData: CmsPayAsYouGoModal;
    private state: StateService;
    
    constructor(accountModal: MyAccountModal, xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { accountModal, xmStore, state, addonsUtil });
    }
    public ngOnInit(): void {

        this.intent = this.addonsUtil.addonAction;
        this.addonType = this.addonsUtil.addonType;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsAddonPlans>(CmsAddonPlans), (result: CmsAddonPlans) => {
            this.planData = result.plans.find((plan: CmsAddonPlan) => plan.gtp1B && plan.type === this.addonType);
            this.summaryPageData = this.planData.content.summaryData;
            this.features = this.intent === 'add' ? this.summaryPageData.addConfirmPointers : this.summaryPageData.removeConfirmPointers;

        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccountModals>(CmsMyAccountModals), (cms: CmsMyAccountModals) => {
            this.payAsYouGoModalData = cms.modals.payAsYouGoModal;
        }));

        this.circleCheckGreyIcon = {
            mobile: Cloudinary.generateMediaFromCms(this.summaryPageData.circleCheckGreyIcon)
        };  
    }

    public launchPayAsYouGoModal(): void {
        this.accountModal.open(XmPayAsYouGoModal, this.payAsYouGoModalData);
    }

    public redirectToLink(link: string): void {
        if (link) {
            this.state.go(link);
        } 
    }
    
}
